import money from 'vuejs-money';
import coco_mask from '@Util/v-coco-mask';
import Vue from 'vue';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import VeeValidate from 'vee-validate';
import './rules';

Vue.use(money);
Vue.use(coco_mask);
Vue.use(VeeValidate, {
  inject: false,
  dictionary: {
    en: ptBR
  },
  delay: 10
});
